const config = {
	env: "local",
	apiUrl: "https://hmrc-api.chabhiwala.com/admin/v1",
};



export default config;
